import { piqureWrapper } from 'piqure';

const { provideLazy, inject } = piqureWrapper(globalThis, 'piqure.account');

export { provideLazy, inject };
